"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'FormDateRange',
  props: {
    rangeType: {
      type: String,
      default: 'daterange'
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 挂载省市区字段的对象
    targetForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 开始、结束时间 字段的key
    keyList: {
      type: Array,
      default: function _default() {
        return ['starttime', 'endtime'];
      }
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    pickerOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 格式化输入
    valueformat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    // placeholder
    startPlaceholder: {
      type: String,
      default: ''
    },
    // placeholder
    endPlaceholder: {
      type: String,
      default: ''
    },
    //
    defaultTime: {
      type: Array,
      default: function _default() {
        return ['00:00:00', '23:59:59'];
      }
    }
  },
  data: function data() {
    return {
      inputVal: null
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    placeholderStartTxt: function placeholderStartTxt() {
      var txt = this.startPlaceholder || this.$t('common.startTime');
      return this.isDisabled ? '' : txt;
    },
    placeholderEndTxt: function placeholderEndTxt() {
      var txt = this.endPlaceholder || this.$t('common.endTime');
      return this.isDisabled ? '' : txt;
    },
    timeRangeWatcher: function timeRangeWatcher() {
      var keys = this.keyList || [];
      var startTime = keys[0] ? this.targetForm[keys[0]] : '';
      var endTime = keys[1] ? this.targetForm[keys[1]] : '';
      // console.log(keys[0], keys[1], this.targetForm[keys[0]])
      return {
        startTime: startTime,
        endTime: endTime
      };
    }
  },
  watch: {
    timeRangeWatcher: {
      deep: true,
      immediate: true,
      handler: function handler() {
        var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var oldObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var startTime = obj.startTime || '';
        var oldStartTime = oldObj.startTime || '';
        var endTime = obj.endTime || '';
        var oldEndTime = oldObj.endTime || '';
        if (startTime !== oldStartTime || endTime !== oldEndTime) {
          if (startTime && endTime) {
            this.inputVal = [startTime, endTime];
          } else {
            this.inputVal = null;
          }
        }
      }
    }
  },
  methods: {
    onChange: function onChange(val) {
      if (this.isDisabled) {
        return false;
      }
      // console.log('change', val)
      var keys = this.keyList || [];
      if (val && val.length && val.length === 2) {
        this.setVal(keys[0], val[0]);
        this.setVal(keys[1], val[1]);
      } else {
        this.setVal(keys[0], '');
        this.setVal(keys[1], '');
      }
    },
    // 外部数据赋值
    setVal: function setVal(key, val) {
      if (this.targetForm) {
        if (key) {
          this.targetForm[key] = val;
        }
      }
    }
  }
};